import React from "react";
import ServicesSection from "../pages/ServicesSection";
import FactsNumberSection from "../pages/FactsNumberSection";
import WhyChooseSection from "../pages/WhyChooseSection";
import AboutTestimonials from "../pages/AboutTestimonials";

const AboutSection = () => {
  return (
   <>
       <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">About us</h2>
          </div>
        </div>
      </div>
    </div>

    <section className="section about-sec">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Image Section */}
          <div className="col-lg-6" data-aos="fade-down">
            <div className="about-img">
              <div className="about-exp">
                <span>12+ years of experiences</span>
              </div>
              <div className="abt-img">
                <img
                  src="/img/about-us.png"
                  className="img-fluid"
                  alt="About us"
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="col-lg-6" data-aos="fade-down">
            <div className="about-content">
              <h6>ABOUT OMSHREE CAB</h6>
              <h2>Reliable & Comfortable Cab Services</h2>

              <p>
                Omshree Cab is a trusted cab service provider dedicated to
                offering safe, reliable, and comfortable travel experiences.
                With years of experience in the transportation industry, we
                ensure that every journey with us is smooth, convenient, and
                affordable.
              </p>

              <p>
                Whether you need a ride for local travel, airport transfers,
                outstation trips, or corporate transportation, Omshree Cab
                provides well-maintained vehicles and professional drivers to
                meet your travel needs. Our goal is to deliver punctual service
                with the highest level of customer satisfaction.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <ul>
                    <li>Professional & experienced drivers</li>
                    <li>Clean and well-maintained vehicles</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul>
                    <li>24/7 customer support</li>
                    <li>Affordable and transparent pricing</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
   
   <ServicesSection/>
   <FactsNumberSection/>
   {/* <WhyChooseSection/> */}
   <AboutTestimonials/>
   
   </>
  );
};

export default AboutSection;